var _ref;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      version: 1.1,
      id: "svg25",
      width: 208.56,
      height: 65.653336,
      viewBox: "0 0 208.56 65.653336"
    }, props), _ref || (_ref =
    /*#__PURE__*/
    React.createElement("defs", {
      id: "defs29"
    })),
    /*#__PURE__*/
    React.createElement("g", {
      id: "g33",
      inkscapeGroupmode: "layer",
      inkscapeLabel: "Page 1",
      transform: "matrix(1.3333333,0,0,-1.3333333,0,65.653333)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "g35",
      transform: "scale(0.1)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M 123.102,492.406 C 55.1133,492.406 0,437.293 0,369.305 V 123.102 C 0,55.1133 55.1133,0 123.102,0 h 246.203 c 67.984,0 123.101,55.1133 123.101,123.102 V 492.406 H 123.102",
      style: {
        "fill": "#9cd747",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path37"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 134.582,295.781 c -4.031,17.61 13.547,33.192 36.27,33.192 20.472,0 40.992,-4.59 48.8,-33.129 h 26.243 v -43.567 c -32.719,26.899 -103.653,10.024 -111.313,43.504 z m 272.305,12.055 h -59.121 l -56.243,-61.59 v 123.059 h -45.628 v -29.817 c -1.489,1.922 -3.059,3.832 -4.821,5.696 -16.59,17.566 -40.5,26.472 -71.062,26.472 -35.348,0 -55.449,-15.82 -66.086,-29.09 -13.2112,-16.472 -19.1057,-38.957 -15.0237,-57.273 10.5704,-47.43 54.5817,-55.004 86.9067,-59.207 25.527,-3.32 49.945,-7.957 49.293,-30.703 -0.672,-23.61 -27.286,-29.414 -44.754,-29.414 -45.496,0 -47.035,33.625 -47.035,33.625 H 84.3828 c 0.7149,-12.625 4.5352,-32.899 20.0782,-50.301 17.023,-19.059 42.559,-28.723 75.887,-28.723 25.57,0 48.855,8.332 65.547,23.121 v -20.328 h 45.628 v 58.09 l 16.149,17.664 46.094,-75.754 h 53.105 l -67.07,110.95 67.086,73.523",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path39"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 668.047,225.52 c 8.648,0 15.133,1 19.457,2.996 7.648,3.492 11.473,10.39 11.473,20.703 0,11.14 -3.7,18.621 -11.098,22.449 -4.16,2.16 -10.399,3.238 -18.711,3.238 H 624.52 V 225.52 h 43.527 z m -3.867,-30.43 h -39.66 v -72.086 h -37.54 v 183.832 h 90.172 c 12.887,-0.25 22.801,-1.828 29.743,-4.738 6.941,-2.914 12.824,-7.196 17.648,-12.848 3.992,-4.656 7.148,-9.812 9.48,-15.465 2.325,-5.656 3.493,-12.097 3.493,-19.332 0,-8.73 -2.207,-17.312 -6.614,-25.754 -4.406,-8.437 -11.679,-14.402 -21.824,-17.894 8.481,-3.41 14.488,-8.254 18.024,-14.532 3.531,-6.277 5.3,-15.859 5.3,-28.746 V 155.18 c 0,-8.399 0.328,-14.09 0.996,-17.086 0.997,-4.739 3.325,-8.231 6.985,-10.477 v -4.613 h -42.278 c -1.167,4.07 -1.996,7.359 -2.496,9.851 -0.996,5.157 -1.539,10.434 -1.621,15.84 l -0.25,17.086 c -0.168,11.723 -2.308,19.539 -6.422,23.446 -4.117,3.91 -11.828,5.863 -23.136,5.863",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path41"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 839.031,204.566 c -0.582,9.399 -3.429,16.528 -8.543,21.391 -5.113,4.863 -11.457,7.297 -19.019,7.297 -8.231,0 -14.614,-2.578 -19.145,-7.734 -4.531,-5.157 -7.379,-12.141 -8.543,-20.954 z m 35.168,-41.652 c -0.914,-8.066 -5.109,-16.258 -12.594,-24.57 -11.64,-13.219 -27.937,-19.828 -48.89,-19.828 -17.293,0 -32.551,5.566 -45.77,16.711 -13.218,11.14 -19.832,29.265 -19.832,54.375 0,23.531 5.965,41.574 17.899,54.128 11.929,12.551 27.418,18.833 46.457,18.833 11.304,0 21.492,-2.122 30.554,-6.364 9.063,-4.238 16.547,-10.933 22.45,-20.078 5.32,-8.066 8.769,-17.418 10.351,-28.062 0.914,-6.235 1.289,-15.215 1.121,-26.938 h -93.039 c 0.5,-13.637 4.782,-23.195 12.848,-28.683 4.906,-3.411 10.809,-5.114 17.711,-5.114 7.312,0 13.262,2.078 17.832,6.235 2.496,2.246 4.699,5.363 6.609,9.355 h 36.293",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path43"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 941.613,262.813 c 16.961,0 30.809,-3.372 41.532,-10.102 10.64,-6.82 16.753,-18.543 18.335,-35.172 h -35.546 c -0.5,4.57 -1.789,8.188 -3.868,10.852 -3.906,4.82 -10.558,7.23 -19.953,7.23 -7.73,0 -13.242,-1.203 -16.523,-3.613 -3.285,-2.414 -4.93,-5.238 -4.93,-8.485 0,-4.074 1.746,-7.027 5.238,-8.851 3.493,-1.914 15.84,-5.199 37.043,-9.856 14.133,-3.324 24.735,-8.355 31.801,-15.089 6.988,-6.821 10.478,-15.34 10.478,-25.567 0,-13.469 -5.01,-24.465 -15.029,-32.988 -10.019,-8.52 -25.503,-12.781 -46.457,-12.781 -21.367,0 -37.144,4.507 -47.328,13.531 -10.187,9.019 -15.277,20.516 -15.277,34.484 h 36.043 c 0.746,-6.32 2.367,-10.808 4.863,-13.468 4.406,-4.743 12.551,-7.11 24.445,-7.11 6.985,0 12.532,1.039 16.649,3.117 4.113,2.078 6.172,5.196 6.172,9.352 0,3.992 -1.664,7.027 -4.988,9.105 -3.325,2.078 -15.672,5.653 -37.04,10.727 -15.382,3.824 -26.234,8.605 -32.55,14.344 -6.321,5.652 -9.481,13.797 -9.481,24.441 0,12.555 4.926,23.344 14.781,32.363 9.852,9.024 23.715,13.536 41.59,13.536 v 0",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path45"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M 1056.14,258.945 V 123.004 h -36.05 v 135.941 z m 0,49.012 v -32.801 h -36.05 v 32.801 h 36.05",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path47"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 1107.32,190.102 c 0,-12.555 2.5,-22.575 7.49,-30.055 4.9,-7.57 12.39,-11.352 22.45,-11.352 10.06,0 17.71,3.743 22.94,11.227 5.24,7.48 7.86,17.168 7.86,29.058 0,16.625 -4.2,28.516 -12.59,35.668 -5.16,4.321 -11.15,6.485 -17.96,6.485 -10.4,0 -18.03,-3.93 -22.89,-11.785 -4.86,-7.86 -7.3,-17.606 -7.3,-29.246 z m 95.79,116.484 V 123.004 h -34.55 v 18.832 c -5.07,-8.066 -10.85,-13.926 -17.34,-17.586 -6.48,-3.656 -14.55,-5.488 -24.19,-5.488 -15.88,0 -29.25,6.426 -40.1,19.269 -10.85,12.848 -16.27,29.328 -16.27,49.449 0,23.2 5.34,41.45 16.02,54.754 10.69,13.301 24.97,19.954 42.84,19.954 8.24,0 15.55,-1.809 21.95,-5.426 6.41,-3.617 11.6,-8.625 15.59,-15.028 v 64.852 h 36.05",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path49"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 1307.7,204.566 c -0.58,9.399 -3.43,16.528 -8.54,21.391 -5.12,4.863 -11.46,7.297 -19.02,7.297 -8.24,0 -14.62,-2.578 -19.15,-7.734 -4.53,-5.157 -7.38,-12.141 -8.54,-20.954 z m 35.17,-41.652 c -0.92,-8.066 -5.12,-16.258 -12.6,-24.57 -11.64,-13.219 -27.93,-19.828 -48.89,-19.828 -17.29,0 -32.55,5.566 -45.77,16.711 -13.22,11.14 -19.83,29.265 -19.83,54.375 0,23.531 5.97,41.574 17.9,54.128 11.93,12.551 27.41,18.833 46.46,18.833 11.3,0 21.49,-2.122 30.55,-6.364 9.06,-4.238 16.55,-10.933 22.45,-20.078 5.32,-8.066 8.77,-17.418 10.35,-28.062 0.92,-6.235 1.29,-15.215 1.12,-26.938 h -93.03 c 0.49,-13.637 4.78,-23.195 12.84,-28.683 4.91,-3.411 10.81,-5.114 17.71,-5.114 7.32,0 13.26,2.078 17.84,6.235 2.49,2.246 4.69,5.363 6.61,9.355 h 36.29",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path51"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 1442.24,222.152 c -3.49,6.985 -10.15,10.477 -19.96,10.477 -12.05,0 -20.33,-5.113 -24.82,-15.34 -2.32,-5.406 -3.49,-12.305 -3.49,-20.703 v -73.582 h -35.42 v 135.691 h 34.3 v -19.832 c 4.57,6.989 8.9,12.016 12.97,15.094 7.32,5.484 16.59,8.231 27.81,8.231 14.05,0 25.55,-3.68 34.49,-11.04 8.93,-7.355 13.4,-19.558 13.4,-36.601 v -91.543 h -36.41 v 82.687 c 0,7.149 -0.96,12.637 -2.87,16.461 v 0",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path53"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "m 1564.23,148.32 v -26.562 l -16.83,-0.625 c -16.8,-0.582 -28.27,2.328 -34.42,8.73 -4,4.075 -5.99,10.352 -5.99,18.832 v 83.684 h -18.96 v 25.316 h 18.96 v 37.914 h 35.17 v -37.914 h 22.07 v -25.316 h -22.07 v -71.836 c 0,-5.57 0.7,-9.043 2.12,-10.414 1.41,-1.371 5.74,-2.059 12.97,-2.059 1.08,0 2.22,0.02 3.43,0.063 1.2,0.043 2.39,0.105 3.55,0.187",
      style: {
        "fill": "#404c4f",
        "fillOpacity": 1,
        "fillRule": "nonzero",
        "stroke": "none"
      },
      id: "path55"
    }))))
  );
};

export default __webpack_public_path__ + "static/media/sk-logo.74e900b2.svg";
export { SvgComponent as ReactComponent };